// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","roundBtn":"Button_roundBtn__E6qJe"};